import Table from '@/common/Table';
import EditableDateCell from '@/common/Table/cells/EditableDateCell';
import EditableTimeCell from '@/common/Table/cells/EditableTimeCell';
import { DATE_FE_FORMAT_SHORT, INVALID_DATE_STRING } from '@/constants';
import { getClasses } from '@/utils';
import { Dayts } from '@/utils/Dayts';
import { useState } from 'react';
import { useManifestState } from '../store';

export type ScheduledCellProps = {
  value: string;
  onChange: (val: string) => void;
  id: string;
};

const ScheduledCell = ({ value, onChange, id }: ScheduledCellProps): JSX.Element => {
  const [{ isInvalid, changedDate, changedTime }, setState] = useManifestState(({ state, setState }) => [
    {
      isInvalid: Object.keys(state.manifestPreview.invalidStagedTrips).includes(id),
      changedDate: !!state.manifestPreview.invalidStagedTrips[id]?.date,
      changedTime: !!state.manifestPreview.invalidStagedTrips[id]?.time,
    },
    setState,
  ]);

  const [scheduled, setScheduled] = useState(value === INVALID_DATE_STRING ? undefined : value);

  const scheduledDate =
    !scheduled || scheduled === INVALID_DATE_STRING ? undefined : new Dayts(scheduled).formatAs(Dayts.Format.DATE_FE_FULL);
  const scheduledTime = !scheduled || scheduled === INVALID_DATE_STRING ? undefined : new Dayts(scheduled).formatAs(Dayts.Format.TIME);

  if (isInvalid)
    return (
      <>
        <EditableDateCell
          className={getClasses('DATE', isInvalid && 'MISSING')}
          value={changedDate ? [scheduledDate] : []}
          format={DATE_FE_FORMAT_SHORT}
          onChange={(val) => {
            let updatedDate = new Dayts(scheduled);
            updatedDate = updatedDate.setDate(val || '01/01/99');
            setScheduled(updatedDate.formatAs());
            setState((current) => ({
              ...current,
              manifestPreview: {
                ...current.manifestPreview,
                invalidStagedTrips: {
                  ...current.manifestPreview.invalidStagedTrips,
                  [id]: { ...current.manifestPreview.invalidStagedTrips[id], date: val },
                },
              },
            }));
            if (changedTime) onChange(updatedDate.formatAs());
          }}
        />
        <EditableTimeCell
          className={getClasses('SCH', isInvalid && 'MISSING')}
          value={changedTime ? scheduledTime : ''}
          onChange={(val) => {
            val = val || '00:00';
            let updatedTime = new Dayts(scheduled);
            updatedTime = updatedTime.setTime(val);
            setScheduled(updatedTime.formatAs());
            setState((current) => ({
              ...current,
              manifestPreview: {
                ...current.manifestPreview,
                invalidStagedTrips: {
                  ...current.manifestPreview.invalidStagedTrips,
                  [id]: { ...current.manifestPreview.invalidStagedTrips[id], time: val },
                },
              },
            }));
            if (changedDate) onChange(updatedTime.formatAs());
          }}
        />
      </>
    );
  return (
    <>
      <Table.Cell className={'DATE'}>{new Dayts(scheduledDate).formatAs(Dayts.Format.DATE_FE_SHORT)}</Table.Cell>
      <Table.Cell className={'SCH'}>{scheduledTime}</Table.Cell>
    </>
  );
};
export default ScheduledCell;
